<template>
    <div class="services-sms-create">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Criar campanha com variáveis</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <!-- Formulário da Campanha com variáveis -->
        <mu-form-sms-vars></mu-form-sms-vars>

    </div>
</template>

<script>
    export default {
        name: 'services-sms-create-dashboard',
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Serviços',
                        route: 'app.services',
                        disabled: false
                    },
                    {
                        text: 'Campanhas',
                        route: 'app.services.sms',
                        disabled: false
                    },
                    {
                        text: 'Criar campanha com variáveis',
                        disabled: true
                    }
                ]
            }
        }
    }
</script>
